import React from 'react';
import BoggleBoard from './BoggleBoard';

const BoggleGame: React.FC = () => {
  return (
    <div className="boggle-game">
      <BoggleBoard />
    </div>
  );
}

export default BoggleGame;